import React from "react";
import { routerActions } from "connected-react-router";

import MainContainer from "pages/_components/MainContainer";
import { Col, Row } from "react-bootstrap";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import { TransactionCard, TransactionSign } from "pages/_components/TransactionCard";
import * as i18n from "util/i18n";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedDate from "pages/_components/FormattedDate";
import CustomProductHead from "pages/_components/CustomProductHead";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import { bool } from "prop-types";
import { useCheckbookTransaction } from "./hooks/useCheckbookTransaction";
import { TransactionHeader } from "./components/TransactionHeaderCheckbook";
import CheckbookSummary from "./components/CheckbookSummary";

const PendingBackofficeApprovePage = ({ isDesktop }) => {
    const { isLoading, transaction, dispatch, isBackoffice } = useCheckbookTransaction();
    const pendingApproval = () => [
        i18n.get("pending.approval"),
        <br />,
        <FormattedDate date={Date.now()} dateFormat="DD/MM/YYYY - HH:mm:ss a" />,
    ];
    return (
        <>
            {!isBackoffice && (
                <CustomProductHead titleId="checks.createCheckbook.title">
                    <div className="toolbar-item view-title">
                        <ViewTitle id="checks.createCheckbook.title" />
                    </div>
                </CustomProductHead>
            )}
            <MainContainer showLoader={isLoading}>
                <div className="container">
                    <TransactionCard transaction={transaction}>
                        <TransactionHeader subTitle="forms.transaction.ticket.status.PROCESSING" />
                        <div className="ticket">
                            <div className="ticket__wrapper">
                                <div className="ticket__header" style={{ marginBottom: isDesktop ? "-20px" : "0" }} />
                                <CheckbookSummary
                                    title="activities.request.checkbook.send"
                                    style={{ gridTemplateColumns: "repeat(1, 1fr)" }}
                                />
                                <div className="ticket__body">
                                    <TransactionSign creationTime isSmall isDesktop={isDesktop} showMoreData />
                                </div>
                                <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                            </div>
                        </div>
                    </TransactionCard>
                    <CustomData
                        icon="alert.svg"
                        dataClass="data-wrapper notification-info notification"
                        titleText={pendingApproval()}
                    />
                    {!isBackoffice && (
                        <Row className="form-actions">
                            <Col xs={12} md={4} mdOffset={4}>
                                <CustomButton
                                    func={() => dispatch(routerActions.push("/desktop"))}
                                    text="forms.transaction.ticket.actions.backToHome"
                                    textType="I18N"
                                    className="btn btn-primary"
                                />
                            </Col>
                        </Row>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

PendingBackofficeApprovePage.propTypes = {
    isDesktop: bool.isRequired,
};

export default PendingBackofficeApprovePage;
